export default __webpack_public_path__ + "static/media/prod3.fa4e8fa1.png";